export const TABLE_EXPORT_SELECTION_TOP_N_VALUES: readonly number[] = [50, 100, 250, 500, 1_000, 5_000, 10_000, 50_000];
